import React, { useState, useRef, useEffect } from 'react';
import { incidentApi } from '../services/incidentApi';

export default function AssetSelector({ value, onChange, placeholder = 'Buscar equipo...' }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const handleClick = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSearch = (q) => {
    setQuery(q);
    if (value) onChange(null);
    clearTimeout(timer.current);
    if (q.length < 2) { setResults([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try { const r = await incidentApi.searchAssets(q); setResults(r); setOpen(true); }
      catch {} finally { setLoading(false); }
    }, 300);
  };

  const handleSelect = (asset) => {
    onChange(asset);
    setQuery(asset.hostname);
    setOpen(false);
  };

  const handleClear = () => { onChange(null); setQuery(''); setResults([]); };

  const statusColor = (s) => ({ active: '#1A6E2E', warning: '#D45D00', critical: '#C0392B', offline: '#5A5A5A' }[s] || '#5A5A5A');

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <input
          className="form-input"
          value={value ? value.hostname : query}
          onChange={e => handleSearch(e.target.value)}
          placeholder={placeholder}
          style={{ paddingRight: value ? 32 : 14, background: value ? '#f0f7ff' : '#fff' }}
        />
        {value && (
          <button onClick={handleClear} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 16, lineHeight: 1 }}>&#10005;</button>
        )}
        {loading && <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', width: 14, height: 14, border: '2px solid #ddd', borderTopColor: '#0063A5', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />}
      </div>

      {value && (
        <div style={{ marginTop: 6, padding: '8px 12px', background: '#e8f1f8', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: statusColor(value.status), flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: '#0063A5', fontFamily: 'monospace' }}>{value.hostname}</div>
            {value.user_name && <div style={{ fontSize: 11, color: '#666' }}>{value.user_name} · {value.os_name}</div>}
          </div>
        </div>
      )}

      {open && results.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 50, marginTop: 4, maxHeight: 240, overflowY: 'auto' }}>
          {results.map(a => (
            <div key={a.id} onClick={() => handleSelect(a)} style={{ padding: '10px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #f5f5f5' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: statusColor(a.status), flexShrink: 0 }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, fontFamily: 'monospace' }}>{a.hostname}</div>
                {a.user_name && <div style={{ fontSize: 11, color: '#888' }}>{a.user_name} · {a.os_name}</div>}
              </div>
            </div>
          ))}
        </div>
      )}

      {open && results.length === 0 && !loading && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 8, padding: '12px 14px', fontSize: 13, color: '#888', zIndex: 50, marginTop: 4 }}>
          Sin resultados para "{query}"
        </div>
      )}
    </div>
  );
}
